import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";
import { getRentalsReportApi, getLocationsReportApi, getRevenueReportApi } from "../../helpers/api/reports";

import { ReportsActionTypes } from "./constants";
import { ReportsApiResponseSuccess, ReportsApiResponseError } from "./actions";

// Rentals Report Saga
function* getRentalsReportSaga({
  payload: { type, startDate, endDate, packageType, rentalStatus, paymentStatus, locationId, corporateId, page, limit, userId, show_deleted },
}: any): SagaIterator {
  try {
    const response = yield call(
      getRentalsReportApi,
      type,
      startDate,
      endDate,
      packageType,
      rentalStatus,
      paymentStatus,
      locationId,
      corporateId,
      page,
      limit,
      userId,
      show_deleted
    );
    const data = response?.data?.data;

    yield put(ReportsApiResponseSuccess(ReportsActionTypes.GET_RENTALS_REPORT, data));
  } catch (error: any) {
    yield put(ReportsApiResponseError(ReportsActionTypes.GET_RENTALS_REPORT, error));
  }
}

// Revenue Report Saga
function* getRevenueReportSaga({ payload: { type, startDate, endDate, packageType, locationId, corporateId, page, limit, userId, show_deleted } }: any): SagaIterator {
  try {
    const response = yield call(getRevenueReportApi, type, startDate, endDate, packageType, locationId, corporateId, page, limit, userId, show_deleted);
    const data = response?.data?.data;

    yield put(ReportsApiResponseSuccess(ReportsActionTypes.GET_REVENUE_REPORT, data));
  } catch (error: any) {
    yield put(ReportsApiResponseError(ReportsActionTypes.GET_REVENUE_REPORT, error));
  }
}

// Locations Report Saga
function* getLocationsReportSaga({ payload: { type } }: any): SagaIterator {
  try {
    const response = yield call(getLocationsReportApi, type);
    const data = response?.data?.data;

    yield put(ReportsApiResponseSuccess(ReportsActionTypes.GET_LOCATION_REPORT, data));
  } catch (error: any) {
    yield put(ReportsApiResponseError(ReportsActionTypes.GET_LOCATION_REPORT, error));
  }
}

// Watchers
export function* watchGetRentalsReport() {
  yield takeEvery(ReportsActionTypes.GET_RENTALS_REPORT, getRentalsReportSaga);
}

export function* watchGetLocationsReport() {
  yield takeEvery(ReportsActionTypes.GET_LOCATION_REPORT, getLocationsReportSaga);
}

export function* watchGetRevenueReport() {
  yield takeEvery(ReportsActionTypes.GET_REVENUE_REPORT, getRevenueReportSaga);
}

// Root Saga
function* ReportsSaga() {
  yield all([fork(watchGetRentalsReport), fork(watchGetLocationsReport), fork(watchGetRevenueReport)]);
}

export default ReportsSaga;
